import { Typography } from '@mui/material';
import { Link } from 'react-scroll';
// import fonts from '../images/fonts.png';
import Grid from '@mui/material/Grid';
import Female from '../images/Female.jpg'
import newMalle from '../images/newMalle.jpg'
import { Container} from '@mui/material';

const Mains = () => {
    return (
        <Grid container spacing={2} alignItems="center" justifyContent="center" sx={{ padding: "0px 7rem" }}>
            <Grid item xs={12} sm={6}>
                <img
                    src={newMalle}
                    style={{ width: '100%', height: '100%' }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <div className="text-container">
                    <Typography variant="h5" sx={{
                        padding: "10px", fontSize: "28px",
                        fontWeight: "600"
                    }}>Mr MITESH R AMIN</Typography>
                    <Typography variant="body1" sx={{ padding: "10px", textAlign: "justify" }}>
                        Public Prosecutor - PP<br></br>
                        High Court Of Gujarat<br></br>
                        Office Of The Government Law Officers, State Of Gujarat<br></br>
                    </Typography>
                </div>
            </Grid>
        </Grid >



    )
}

export default Mains;
